import { Children } from 'react';
import '../classes/styles/style.css';
import * as WS from '../webServices/cyMyManager'

type ModalProps = {
    isShow: boolean;
    onClose: () => void;
    onSave?: () => void;
    onDel?: () => Promise<void>;
    title?: string;
    body?: React.ReactNode;
};

export default function Modal(props: ModalProps): JSX.Element {
    const modalShow = `modal fade ${props.isShow ? "show" : ""}`;
    const backdropShow = props.isShow ? "modal-backdrop show" : "modal-backdrop";

    return (
        <div>
            <div className={backdropShow} style={{ display: (props.isShow ? "block" : "none") }} onClick={() => props.onClose()}></div>
            <div className={modalShow} style={{ display: (props.isShow ? "block" : "none"), }} tabIndex={-1} id="miaModal" aria-labelledby="modalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg ">
                    <div className="modal-content" style={{ maxHeight: '700px' }}>
                        <div className="modal-header">
                            <h5 className="modal-title">{props.title}</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => props.onClose()}
                            />
                        </div>
                        <div className="modal-body" style={{overflow: 'auto'}}>
                            {props.body}
                        </div>
                        <div className="modal-footer">
                            {props.onDel &&
                                <button type="button" onClick={() => props.onDel?.()} className="btn btn-danger">
                                    Elimina
                                </button>
                            }
                            {props.onSave && (
                                <button type="button" className="btn btn-primary" onClick={() => props.onSave?.()}>
                                    Salva
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}